import React, { useEffect, useRef, useState } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './Layout.scss';
import { Outlet, useLocation } from 'react-router-dom';
import ErrorBoundary from '../component/ErrorBoundary';
import UsageLimitBanner from '../component/DashboardBanner/UsageLimitBanner';

const Layout = () => {
	const [collapsed, setCollapsed] = useState(false);
	const inputRef = useRef(null);

	const location = useLocation();
	// Clear URL query parameters across all modules
	useEffect(() => {
		if (window.location.search) {
			window.history.replaceState(null, '', window.location.pathname);
		}
	}, [location.search, location.pathname]);

	return (
		<div>
			<div>
				<Navbar
					collapsed={collapsed}
					inputRef={inputRef}
					setCollapsed={setCollapsed}
				/>
				{/*
				 * Rendered here (not inside a specific page) so a 90%+ usage alert
				 * stays visible across the whole dashboard, not just one screen —
				 * matches the "persistent alert" requirement rather than a
				 * per-page notice that disappears on navigation.
				 */}
				<UsageLimitBanner />
				<div className="d-flex">
					<Sidebar
						inputRef={inputRef}
						collapsed={collapsed}
						setCollapsed={setCollapsed}
					/>
					<div className="layout-wrapper">
						{/*
						 * Wraps the routed page only, so a crash inside one page keeps the
						 * navbar and sidebar usable and the user can navigate away —
						 * rather than React unmounting the whole tree and leaving a blank
						 * screen. `key` on the route path resets the boundary on
						 * navigation, otherwise a page that errored once would stay
						 * errored after moving elsewhere.
						 */}
						<ErrorBoundary key={location.pathname}>
							<Outlet />
						</ErrorBoundary>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Layout;
